import React, { memo, ReactElement, RefObject } from "react";
import { CartPaymentFooter } from "@cart-ui/components/cart-payment-footer";
import { SlotBottomsheet } from "@cart-ui/components/slot-bottomsheet";
import { useEffectOnce } from "@swiggy-private/core-ui";
import { IDeliverySlots } from "@swiggy-private/cart-types";
import { isEmpty } from "@swiggy-private/core-ui";
import { Container } from "./styles";

export interface PaymentWidgetProps {
    viewDetailedBill: VoidFunction;
    makePayment: (selectedSlot?: string) => void;
    cartTotal: number;
    tipAmount?: number;
    makePaymentButtonRef?: RefObject<HTMLDivElement>;
    canPlaceOrderFromCart?: boolean;
    qFoodSLA?: string;
    onImpressionProceedToPay: VoidFunction;
    deliverySlots?: IDeliverySlots;
    onSlotSelect: Function;
    showSlots: boolean;
    setShowSlots: Function;
    selectDeliverySlot: Function;
    analyticsEvents: {
        impressionProceedToPay: Function;
        impressionSelectDeliverySlotButton: Function;
        impressionAllDelierySlots: Function;
    };
    updateCartInProgress: boolean;
    isBulkOrder: boolean;
    billToCompanyWidget?: ReactElement;
}

function PaymentWidget(props: PaymentWidgetProps): ReactElement {
    const {
        cartTotal,
        makePayment,
        viewDetailedBill,
        tipAmount,
        makePaymentButtonRef,
        canPlaceOrderFromCart,
        onImpressionProceedToPay,
        onSlotSelect,
        showSlots,
        setShowSlots,
        analyticsEvents,
        updateCartInProgress,
        billToCompanyWidget,
    } = props;
    const isSlotEnabled = !isEmpty(props.deliverySlots);

    useEffectOnce(() => {
        onImpressionProceedToPay();
    });

    return (
        <>
            {/* adding the condition to check if cartTotal is not 0 to avoid rendering billToCompanyWidget 
                as in this case we use to call direct place order api with payment method as CASH */}
            {!isEmpty(cartTotal) && billToCompanyWidget}
            <Container>
                {showSlots && (
                    <SlotBottomsheet
                        cartTotal={cartTotal}
                        tipAmount={tipAmount}
                        makePayment={makePayment}
                        viewDetailedBill={viewDetailedBill}
                        canPlaceOrderFromCart={canPlaceOrderFromCart}
                        makePaymentButtonRef={makePaymentButtonRef}
                        setShowSlots={setShowSlots}
                        deliverySlots={props.deliverySlots}
                        onSlotSelect={onSlotSelect}
                        selectDeliverySlot={props.selectDeliverySlot}
                        analyticsEvents={{
                            impressionProceedToPay: analyticsEvents.impressionProceedToPay,
                            impressionSelectDeliverySlotButton: analyticsEvents.impressionSelectDeliverySlotButton,
                            impressionAllDelierySlots: analyticsEvents.impressionAllDelierySlots,
                        }}
                        updateCartInProgress={updateCartInProgress}
                        isBulkOrder={props.isBulkOrder}
                    />
                )}
                <CartPaymentFooter
                    cartTotal={cartTotal}
                    tipAmount={tipAmount}
                    makePayment={makePayment}
                    viewDetailedBill={viewDetailedBill}
                    canPlaceOrderFromCart={canPlaceOrderFromCart}
                    makePaymentButtonRef={makePaymentButtonRef}
                    isSlotEnabled={isSlotEnabled}
                    selectDeliverySlot={props.selectDeliverySlot}
                    impressionProceedToPay={analyticsEvents.impressionProceedToPay}
                    impressionSelectDeliverySlotButton={analyticsEvents.impressionSelectDeliverySlotButton}
                />
            </Container>
        </>
    );
}

export default memo(PaymentWidget);
